// src/api/request.ts
import { AxiosResponse } from 'axios';
import { REQUEST_TIMEOUT } from './config';
import { createAxiosInstance } from './axiosInstance';
interface RequestConfig {
  method?: string;
  url: string;
  data?: unknown;
  params?: Record<string, unknown>;
  headers?: Record<string, string>;
  base?: string;
  requiresAuth?: boolean;
  requiresRestaurantId?: boolean;
  timeout?: number;
  contentType?: string;
  responseType?:
    | 'json'
    | 'text'
    | 'blob'
    | 'arraybuffer'
    | 'document'
    | 'stream';
}

export const request = <T = unknown>({
  method = 'GET',
  url,
  data,
  params,
  headers,
  base,
  requiresAuth = false,
  requiresRestaurantId = true,
  timeout = REQUEST_TIMEOUT,
  contentType = 'application/json',
  responseType = 'json',
  ...customConfig
}: RequestConfig): Promise<AxiosResponse<T>> => {
  const axiosInstance = createAxiosInstance({
    baseURL: base,
    requiresAuth,
    timeout,
    requiresRestaurantId,
    ...customConfig,
  });

  return axiosInstance({
    method,
    url,
    data,
    params,
    headers: {
      ...(contentType && { 'Content-Type': contentType }),
      ...headers,
    },
    responseType,
    ...customConfig,
  });
};
